import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowRightIcon, ClockIcon } from 'lucide-react';
import { getBlogPosts } from '../data/blogPosts';
import { useLanguage } from '../contexts/LanguageContext';
export function BlogPage() {
  const posts = getBlogPosts();
  const {
    language
  } = useLanguage();
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-394">
      <SEO title={language === 'de' ? 'CRM Kraft Blog - CRM-Strategien und Vertriebstipps' : 'CRM Kraft Blog - CRM Strategies and Sales Tips'} description={language === 'de' ? 'Praxiserprobte CRM-Strategien und Vertriebstipps für mehr Umsatz. Erfahre, wie du dein CRM-System optimierst und deinen Vertrieb auf das nächste Level bringst.' : 'Proven CRM strategies and sales tips for more revenue. Learn how to optimize your CRM system and take your sales to the next level.'} canonical="https://crmkraft.de/blog" data-id="element-395" />
      <Navigation data-id="element-396" />
      <main className="pt-24 pb-16" data-id="element-397">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-398">
          {/* Header */}
          <div className="text-center mb-12 lg:mb-16" data-id="element-399">
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4" data-id="element-400">
              {language === 'de' ? 'CRM Kraft Blog' : 'CRM Kraft Blog'}
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-401">
              {language === 'de' ? 'Praxiserprobte CRM-Strategien und Vertriebstipps für mehr Umsatz' : 'Proven CRM strategies and sales tips for more revenue'}
            </p>
          </div>

          {/* Blog Posts Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-402">
            {posts.map(post => <Link key={post.id} to={`/blog/${post.slug}`} className="group bg-gradient-to-br from-[#1a1f36] to-[#111827] rounded-xl border border-white/10 overflow-hidden hover:border-[#ff6b35]/50 transition-all" data-id="element-403">
                {/* Category Badge */}
                <div className="p-6 pb-4" data-id="element-404">
                  <div className="inline-block bg-[#ff6b35]/10 text-[#ff6b35] text-xs font-semibold px-3 py-1 rounded-full mb-4" data-id="element-405">
                    {post.category[language]}
                  </div>

                  {/* Title */}
                  <h2 className="text-xl font-bold text-white mb-3 group-hover:text-[#ff6b35] transition-colors" data-id="element-406">
                    {post.title[language]}
                  </h2>

                  {/* Excerpt */}
                  <p className="text-gray-400 text-sm mb-4 line-clamp-3" data-id="element-407">
                    {post.excerpt[language]}
                  </p>

                  {/* Meta */}
                  <div className="flex items-center justify-between text-sm text-gray-500" data-id="element-408">
                    <div className="flex items-center gap-2" data-id="element-409">
                      <ClockIcon className="w-4 h-4" data-id="element-410" />
                      <span data-id="element-411">{post.readTime}</span>
                    </div>
                    <div className="flex items-center gap-2 text-[#ff6b35] group-hover:gap-3 transition-all" data-id="element-412">
                      <span className="font-medium" data-id="element-413">
                        {language === 'de' ? 'Lesen' : 'Read'}
                      </span>
                      <ArrowRightIcon className="w-4 h-4" data-id="element-414" />
                    </div>
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-415" />
    </div>;
}